export default {
    totals: 'Totals',
    grand_total: 'Grand Total',
    work_type: 'Activities',
    quantity: 'Quantity',
    total_time: 'Total Time',
    call: {
        category: 'Category',
        total_ticket: 'Total Tickets',
        total_worklload: 'Total Workloads',
        total_time_agreed_load: 'Total Agreed Time',
        agreed_load_variation_percent: 'Agreed Time Difference',
        time_limit_sla: 'SLA Time Limit',
        sla_variation_percent: 'SLA Difference',
    },
    task: {
        type: 'Task Type',
        quantity_task: 'Number of Tasks',
        quantity_items_checklist: 'Number of Checklist Items',
        quantity_items_checklist_completed: 'Number of Completed Items',
        total_time_estimated: 'Total Estimated Time',
        total_time_workload: 'Total Workload Time',
        workload_variation_percent: 'Estimated Time Accuracy'
    }
}
